module.exports = __webpack_public_path__ + "static/logo_white-02b297c72a09d688b0d3ef0a2c4b8680.png";